import React, { Component } from 'react';
import { Spinner } from 'react-activity';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

export class Loader extends Component {
    render() {
        return (
            <div className="flex items-center text-white justify-center h-full">
                <div className="loader-container text-center">
                    <Spinner color="white" />
                    <div className="loader-text">{this.props.t('pleaseWait')}</div>
                </div>
            </div>
        );
    }
}

const ConnectedLoader = withLanguage(Loader);

export default (props) => (
    <LanguageProvider>
        <ConnectedLoader {...props} />
    </LanguageProvider>
);
